<template>
  <v-app-bar
      elevation="0"
      class="header"
  >
    <div class="page-header" :class="$mq">
      <img
          alt="Unistra"
          src="../assets/logo.png"
          class="header-img" :class="$mq"
      />
      <div class="header-right" :class="$mq">
        <menuHeader v-if="$mq == 'smartphone'"/>
        <connect v-if="$mq == 'computer'"/>
        <tabs class="tabs" v-if="$mq == 'computer'"/>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import connect from "./header/connect"
import tabs from "./header/tabs"
import MenuHeader from "./header/menuHeader"

export default {
  name: "headerTest",

  components: {
    MenuHeader,
    connect,
    tabs,
  },
}
</script>

<style lang="scss">
@import "../utilities/variables";

.tabs {
  display: flex;
  justify-content: flex-end;
  width: auto;
}

.v-toolbar__content {
  display: flex;
  justify-content: center;
}

.header-right /*.smartphone*/ {
  display: flex;
  align-items: flex-end;
  justify-content: right;
  width: 100%;
}

.header-right.smartphone {
  padding: 20px 0;
}
/*
.header-right.computer {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
}*/

.page-header.smartphone {
  display: flex;
  //flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%
}

.page-header.computer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;
  max-width: 1785px;
}

.header {
  width: 100%;
  //display: flex;

  background-color: $header-background-color;
  color: $text-color;
  border-bottom: 1px solid;
  border-bottom-color: darken(#e8eff9,15%) !important;
}
/*
.header-img.computer {
  height: 3em;
}

.header-img.smartphone {
  height: 1.5em;
}
 */
</style>
